/**
 * Normalizes user input to a `#RRGGBB` hex color, or null if invalid.
 *
 * @param {string} value Raw input.
 * @returns {string | null}
 */
export function normalizeHexColor(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  let hex = trimmed;
  if (!hex.startsWith('#')) {
    hex = `#${hex}`;
  }

  if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
    return hex.toUpperCase();
  }

  if (/^#[0-9A-Fa-f]{3}$/.test(hex)) {
    const r = hex[1];
    const g = hex[2];
    const b = hex[3];
    return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
  }

  return null;
}

/**
 * Returns a value safe for `<input type="color">` (6-digit hex).
 *
 * @param {string | undefined | null} value Stored hex.
 * @param {string} fallback Default when missing or invalid.
 * @returns {string}
 */
export function hexColorForPicker(value: string | undefined | null, fallback: string): string {
  return normalizeHexColor(value ?? '') ?? normalizeHexColor(fallback) ?? '#4F46E5';
}
